<template>
    <!-- 扫码支付弹窗：样式严格照 v30 单文件 showPayQR，二维码与价格用真实接口数据 -->
    <div v-if="purchaseStore.payVisible" class="payqr_overlay fixed flex-center" @click.self="purchaseStore.closePay()">
        <div class="payqr_card overflow-hidden">
            <!-- 头部 -->
            <div class="pq_head flex items-center justify-between">
                <div>
                    <div class="pq_title">扫码支付</div>
                    <div class="pq_sub">{{ purchaseStore.payProduct?.name || 'Microsoft 365 · 买12个月送3个月' }}</div>
                </div>
                <button class="pq_close flex-center" @click="purchaseStore.closePay()">×</button>
            </div>

            <!-- 价格（真实接口返回） -->
            <div class="pq_price_box ac">
                <span class="pq_price">{{ purchaseStore.payPrice || '—' }}</span>
                <span class="pq_unit"> 元/年</span>
                <div class="pq_orig" v-if="purchaseStore.payProduct?.orig">原价 ¥{{ purchaseStore.payProduct.orig }}</div>
            </div>

            <!-- 二维码（真实接口返回） -->
            <div class="pq_body ac">
                <div class="pq_qr flex-center relative">
                    <img class="pq_qr_img" :src="purchaseStore.payQr" alt="" @error="onQrError">
                    <div v-if="purchaseStore.payReset" class="pq_reset absolute flex-center flex-col pointer"
                        @click="purchaseStore.refreshPay()">
                        <span class="pq_reset_ico">⟳</span>
                        <span class="f12">点击刷新</span>
                    </div>
                </div>
                <div class="pq_scan_t">微信 / 支付宝 扫码支付</div>
                <div class="pq_scan_s">付款后自动生成激活码，即时发货</div>
                <!-- 支付方式 -->
                <div class="pq_methods flex-center">
                    <span class="pm wx">微信支付</span>
                    <span class="pm zfb">支付宝</span>
                </div>
                <button class="pq_paid_btn" @click="purchaseStore.checkPayNow()">✅ 我已完成支付</button>
                <div class="pq_help">支付遇到问题？<a class="pointer"
                        @click="purchaseStore.closePay(); appStore.goPage('page-contact')">联系客服</a></div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const appStore = useAppStore();
const purchaseStore = usePurchaseStore();

// 二维码加载图；真实二维码加载失败时回退显示
const qrLoading = new URL('@/assets/global/qrcode_load.png', import.meta.url).href;
function onQrError(e: Event) {
    const img = e.target as HTMLImageElement;
    if (img && img.src !== qrLoading) img.src = qrLoading;
}
</script>

<style lang="less" scoped>
// 照 v30 showPayQR 内联样式 1:1 迁移
.payqr_overlay {
    inset: 0;
    z-index: 9999;
    background: rgba(10, 8, 30, .65);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
}

.payqr_card {
    width: 360px;
    max-width: 92vw;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0 24px 80px rgba(0, 0, 0, .35);
    animation: fadeSlideIn .22s ease;
}

.pq_head {
    background: linear-gradient(135deg, #6C4EF6, #E879F9);
    padding: 18px 22px;

    .pq_title {
        font-size: 16px;
        font-weight: 900;
        color: #fff;
    }

    .pq_sub {
        font-size: 12px;
        color: rgba(255, 255, 255, .75);
        margin-top: 2px;
    }

    .pq_close {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: none;
        background: rgba(255, 255, 255, .2);
        color: #fff;
        font-size: 16px;
        line-height: 1;
        cursor: pointer;
        flex-shrink: 0;
    }
}

.pq_price_box {
    padding: 16px 22px 0;
    background: rgba(108, 78, 246, .04);
    border-bottom: 1px solid rgba(108, 78, 246, .08);

    .pq_price {
        font-size: 38px;
        font-weight: 900;
        background: linear-gradient(135deg, #6C4EF6, #E879F9);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .pq_unit {
        font-size: 15px;
        font-weight: 700;
        color: #1A1040;
    }

    .pq_orig {
        font-size: 11.5px;
        color: #9B8EC4;
        margin-top: 2px;
        padding-bottom: 14px;
    }
}

.pq_body {
    padding: 20px 22px;

    .pq_qr {
        width: 160px;
        height: 160px;
        margin: 0 auto 12px;
        border: 2px solid rgba(108, 78, 246, .15);
        border-radius: 16px;
        background: rgba(108, 78, 246, .04);
        overflow: hidden;

        .pq_qr_img {
            width: 130px;
            height: 130px;
            object-fit: contain;
        }

        .pq_reset {
            inset: 0;
            gap: 4px;
            border-radius: 16px;
            background: rgba(255, 255, 255, .92);
            color: var(--primary);

            .pq_reset_ico {
                font-size: 30px;
                line-height: 1;
            }
        }
    }

    .pq_scan_t {
        font-size: 13px;
        font-weight: 700;
        color: #1A1040;
        margin-bottom: 4px;
    }

    .pq_scan_s {
        font-size: 11.5px;
        color: #9B8EC4;
        margin-bottom: 16px;
    }

    .pq_methods {
        gap: 8px;
        margin-bottom: 16px;

        .pm {
            color: #fff;
            font-size: 11px;
            font-weight: 700;
            padding: 3px 10px;
            border-radius: 6px;

            &.wx {
                background: #07C160;
            }

            &.zfb {
                background: #1677FF;
            }
        }
    }

    .pq_paid_btn {
        width: 100%;
        padding: 12px;
        background: linear-gradient(135deg, #6C4EF6, #E879F9);
        border: none;
        border-radius: 12px;
        color: #fff;
        font-size: 14px;
        font-weight: 800;
        cursor: pointer;
        box-shadow: 0 4px 16px rgba(108, 78, 246, .4);
    }

    .pq_help {
        font-size: 11px;
        color: #C4B5E8;
        margin-top: 10px;

        a {
            color: #6C4EF6;
            font-weight: 700;
        }
    }
}
</style>
